module.exports = "<svg width=\"36\" height=\"36\" viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\"><title>gallery-icon</title><path d=\"M18 36C8.059 36 0 27.941 0 18S8.059 0 18 0s18 8.059 18 18-8.059 18-18 18zm-5.442-21.767v10.083h14.79V14.233h-14.79zm-1.674-3.35v1.675h12.558v-1.674H10.884zm-1.675 0V20.93h1.675V10.884H9.209z\" fill=\"#FFF\" fill-rule=\"evenodd\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/icons/gallery-icon.svg
// module id = ./node_modules/raw-loader/index.js!./src/icons/gallery-icon.svg
// module chunks = 168707334958949